<template>
    <div class="row justify-content-center align-items-center vh-100 w-100 m-0">
        <div class="col-12 row justify-content-center align-items-center p-0">
            <div class="col-12 col-md-10 col-lg-8 col-xxl-6 p-5 form-box">
                <h2 class="text-center">M&M Security Gatehouse</h2>
                <h3 class="text-center">Zapomenuté heslo</h3>
                <div v-if="!sent">
                    <label for="username" class="my-2">Uživatelské jméno/email</label>
                    <input type="text" id="username" class="form-control" ref="username" v-model="username"
                        :placeholder="'Uživatelské jméno'" @keyup.enter="reset()">
                    <button type="submit" class="mt-4 p-2 btn btn_submit w-100" @click="reset">
                        Resetovat heslo
                    </button>
                </div>
                <div v-else>
                    <h3 class="text-success text-center">Odkaz pro změnu hesla odešel na Váš email.</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: null,
            sent: false
        }
    },
    methods: {
        reset() {
            this.$store.getters.api.post("/auth/reset", { "username": this.username })
            .then(() => {
                this.sent = true;
            })
            .catch(error => {
                alert("Nastala chyba při odesílání emailu");
            });
        }
    }
}
</script>

<style lang="scss"></style>